import { checkIsSignedorNot } from "../../../redux/slices/newRoleSlices";

export const checkDocumentSignedStatus = async (
    dispatch: any,
    candidateId: string,
    formName: string,
    activePageNumber: number,
    formType: "TFN" | "SUPER" | "DYNAMIC"
) => {
    
    const obj: any = {
        CandidateId: candidateId,
        formName,
        activePageNumber,
        isTfnForm: formType === "TFN",
        isSuperForm: formType === "SUPER",
        isDynamicFlkForm: formType === "DYNAMIC",
    };

    const response = await dispatch(checkIsSignedorNot(obj));
    return response?.payload?.data?.message || null;
};
